import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ReactDOM from "react-dom";
import _ from "lodash";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from "@material-ui/core/Dialog";
import TextField from "components/TextField";
import Button from "components/Button";
import CryptoJS from "crypto-js";
import Checkbox from "components/CheckBox";
import CardImage from "assets/images/cardImage.png";
import DeleteIcon from "@material-ui/icons/Delete";
import StripeLogo from "assets/images/stripe.jpeg";
import {
  Container,
  PayableAmount,
  CardField,
  Footer,
  Cvv,
  PaymentOption,
  SavedCard,
  Body,
  DeleteCard,
  CardWrapper,
  StripeImage,
} from "styles/components/Stripe";
import { USD_TO_CAD_CONVERSION_RATE } from "constants/currency";

//const PayPalButton = window.paypal.Buttons.driver("react", { React, ReactDOM });

const Stripe = ({
  open = false,
  hide,
  cards,
  payableAmount,
  removeCards,
  showSaveCardCheckbox = true,
  multiple = false,
  vatIncluded = false,
}) => {
  const currency = useSelector((state) => state?.currency?.value);
  const [selectedPaymentOption, setPaymentOption] = useState(undefined);
  const [paymentInCanadian, setPaymentInCanadian] = useState(false);
  const [isVatIncluded, setVatIncluded] = useState(vatIncluded);
  const [showDisclaimer, setDisclaimer] = useState(true);

  useEffect(() => {
    setPaymentOption(
      !!cards?.length ? "SavedPaymentOptions" : "OtherPaymentOptions"
    );
  }, [cards]);

  const [state, setState] = useState({
    cardNumber: undefined,
    cardExpMonth: undefined,
    cardExpYear: undefined,
    cvv: undefined,
    iossNumber: undefined,
  });

  const [saveCard, setSaveCard] = useState(false);

  const disabled =
    !state?.cardNumber ||
    state?.cardNumber?.trim()?.length < 12 ||
    !state?.cardExpMonth ||
    state?.cardExpMonth?.trim()?.length < 2 ||
    !state?.cardExpYear ||
    state?.cardExpYear?.trim()?.length < 2 ||
    !state?.cvv ||
    state?.cvv?.trim()?.length < 3;

  const payableAmountForMultipleInCad = (orders) => {
    let cost = [];
    for (let i = 0; i < orders?.length; i++) {
      cost.push((orders[i] * USD_TO_CAD_CONVERSION_RATE).toFixed(2));
    }
    return cost.join(", ");
  };

  return (
    <React.Fragment>
      {showDisclaimer ? (
        <Dialog
          maxWidth="xl"
          open={showDisclaimer}
          onClose={() => _.isFunction(hide) && hide()}
        >
          <Container>
            <PayableAmount>
              <h2>International Orders</h2>
            </PayableAmount>
            <Body style={{ fontSize: 20, lineHeight: "35px" }}>
              <p>
                Tracked shipping option is not available for all International
                destinations. Service restrictions applied by Canada Post may
                prevent us to generate a functional tracking number for the
                order. Any order effected by these restrictions cannot be
                tracked by us and will not be refunded in case of loss in
                transit.
              </p>
              <p>
                For complete list of countries and the services offered, please
                review the following links. Pleas note, only Tracked Packet -
                International options allows tracking for an international
                destination.
              </p>
              <a
                target="_blank"
                href="https://www.canadapost-postescanada.ca/cpc/doc/en/aboutus/service-alerts/destinations-to-which-service-is-suspended.pdf"
              >
                https://www.canadapost-postescanada.ca/cpc/doc/en/aboutus/service-alerts/destinations-to-which-service-is-suspended.pdf
              </a>
            </Body>
            <Button
              title="Proceed To Payment"
              containerStyle={{
                backgroundColor: "#1c84c6",
                color: "#fff",
                fontWeight: "bold",
                float: "right",
                marginBottom: 20,
                marginRight: 20,
              }}
              onClick={() => setDisclaimer(false)}
            />
          </Container>
        </Dialog>
      ) : (
        <Dialog
          maxWidth="xl"
          open={open}
          onClose={() => _.isFunction(hide) && hide()}
        >
          <Container>
            {isVatIncluded ? (
              <PayableAmount>
                <h2>Enter IOSS Number</h2>
              </PayableAmount>
            ) : (
              <PayableAmount>
                <h2>Amount Payable</h2>

                {multiple ? (
                  <h2 style={{ maxWidth: 500, overflowWrap: "anywhere" }}>
                    {paymentInCanadian || currency === "CAD"
                      ? payableAmountForMultipleInCad(payableAmount)
                      : payableAmount.join(", ")}
                    &nbsp;
                    {paymentInCanadian || currency === "CAD" ? "CAD" : "USD"}
                  </h2>
                ) : (
                  <h2>
                    {paymentInCanadian || currency === "CAD"
                      ? (payableAmount * USD_TO_CAD_CONVERSION_RATE).toFixed(2)
                      : payableAmount}
                    &nbsp;
                    {paymentInCanadian || currency === "CAD" ? "CAD" : "USD"}
                  </h2>
                )}
              </PayableAmount>
            )}
            {isVatIncluded ? (
              <Body>
                <div
                  style={{
                    margin: "20px 0 0 0",
                    flexDirection: "row",
                    display: "flex",
                    gridGap: 20,
                  }}
                >
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    placeholder="IOSS Number (Optional)"
                    value={state?.iossNumber || ""}
                    onChange={(iossNumber) =>
                      setState({ ...state, iossNumber })
                    }
                  />

                  <Button
                    title="Next"
                    containerStyle={{
                      backgroundColor: "#1c84c6",
                      color: "#fff",
                      fontWeight: "bold",
                    }}
                    onClick={() => setVatIncluded(false)}
                  />
                </div>
                <h3
                  style={{ lineHeight: "30px", color: "orange", fontSize: 20 }}
                >
                  Note : If you will not provide IOSS Number, your customer will
                  get charged on receiving the order. Please click Next to
                  proceed.
                  <br />
                  <br />
                  You will get the IOSS Number for this order from your
                  respective E-Commerce platform.
                </h3>
              </Body>
            ) : (
              <Body>
                <RadioGroup
                  row
                  value={selectedPaymentOption}
                  onChange={(e) => {
                    setPaymentOption(e.target.value);
                    if (e.target.value === "Paypal") {
                      setPaymentInCanadian(false);
                    }
                  }}
                >
                  <PaymentOption>
                    {!!cards?.length && (
                      <FormControlLabel
                        value="SavedPaymentOptions"
                        control={<Radio />}
                        label="Saved Payment Options"
                      />
                    )}
                    <FormControlLabel
                      value="OtherPaymentOptions"
                      control={<Radio />}
                      label="Other Payment Options"
                    />
                    {!multiple && (
                      <FormControlLabel
                        value="Paypal"
                        control={<Radio />}
                        label="Paypal"
                      />
                    )}
                  </PaymentOption>
                </RadioGroup>
                {selectedPaymentOption !== "Paypal" && currency !== "CAD" && (
                  <div
                    style={{
                      padding: "0px 10px 10px",
                      width: 240,
                      margin: "0 auto",
                    }}
                  >
                    <Checkbox
                      value={paymentInCanadian}
                      onChange={() => setPaymentInCanadian(!paymentInCanadian)}
                      label="Pay in Canadian (CAD)"
                    />
                  </div>
                )}

                <div
                  style={{ color: "orange", fontSize: 18, fontWeight: "bold" }}
                >
                  Note: Our current processing timeline is 3 to 7 business days.
                  The production time is from 8 AM to 4 PM EST. Any order placed
                  after 4 PM EST will be considered the next business day and
                  processing timeline will be applied appropriately.
                  <br />
                  <br />
                  Durasoft Decoration Fulfillment times: 8 – 12 business days.
                  <br />
                  DTG Decoration Fulfillment times 3 – 7 business days.
                </div>

                {selectedPaymentOption === "SavedPaymentOptions" ? (
                  <div>
                    <h2>Select card to pay</h2>
                    {cards?.map &&
                      cards.map((card, index) => {
                        const regex = /\b(?:\d{4}[ -]?){3}(?=\d{4}\b)/gm;
                        const mask = `**** **** **** `;
                        const cardNo = CryptoJS.AES.decrypt(
                          card.cardNumber,
                          "bot"
                        ).toString(CryptoJS.enc.Utf8);

                        return (
                          <CardWrapper
                            key={`card${index}`}
                            style={{ display: "flex" }}
                          >
                            <SavedCard
                              onClick={() => {
                                hide({
                                  cardDetails: card,
                                  paymentInCanadian:
                                    paymentInCanadian || currency === "CAD",
                                  iossNumber: state?.iossNumber,
                                });
                              }}
                            >
                              <img src={CardImage} alt="CardImage" />
                              <div>
                                <h3>{cardNo.replace(regex, mask)}</h3>
                                <span>Saved Card</span>
                              </div>
                            </SavedCard>

                            {_.isFunction(removeCards) && (
                              <DeleteCard>
                                <DeleteIcon
                                  style={{
                                    color: "red",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => removeCards(card)}
                                />
                              </DeleteCard>
                            )}
                          </CardWrapper>
                        );
                      })}
                  </div>
                ) : selectedPaymentOption === "OtherPaymentOptions" ? (
                  <React.Fragment>
                    <CardField>
                      <TextField
                        fullWidth
                        size="small"
                        type="number"
                        placeholder="Card Number"
                        value={state?.cardNumber || ""}
                        onChange={(cardNumber) => {
                          if (cardNumber?.toString()?.trim()?.length <= 16) {
                            setState({ ...state, cardNumber });
                          }
                        }}
                      />
                      <Cvv>
                        <TextField
                          fullWidth
                          size="small"
                          type="number"
                          value={state?.cardExpMonth || ""}
                          placeholder="Exp Month"
                          onChange={(cardExpMonth) => {
                            if (cardExpMonth?.toString()?.trim()?.length <= 2) {
                              setState({ ...state, cardExpMonth });
                            }
                          }}
                        />
                        <TextField
                          fullWidth
                          value={state?.cardExpYear || ""}
                          size="small"
                          type="number"
                          placeholder="Exp Year"
                          onChange={(cardExpYear) => {
                            if (cardExpYear?.toString()?.trim()?.length <= 2) {
                              setState({ ...state, cardExpYear });
                            }
                          }}
                        />
                        <TextField
                          fullWidth
                          size="small"
                          type="number"
                          placeholder="CVV"
                          value={state?.cvv || ""}
                          onChange={(cvv) => {
                            if (cvv?.toString()?.trim()?.length <= 4) {
                              setState({ ...state, cvv });
                            }
                          }}
                        />
                      </Cvv>
                    </CardField>

                    {showSaveCardCheckbox && (
                      <Checkbox
                        value={saveCard}
                        onChange={() => setSaveCard(!saveCard)}
                        label="Save Card for future transaction"
                      />
                    )}
                    <Footer>
                      <Button
                        title="Pay"
                        disabled={disabled}
                        onClick={() => {
                          hide({
                            saveCard,
                            iossNumber: state?.iossNumber,
                            cardDetails: {
                              cardNumber: CryptoJS.AES.encrypt(
                                state.cardNumber,
                                "bot"
                              ).toString(),
                              cardExpMonth: CryptoJS.AES.encrypt(
                                state.cardExpMonth,
                                "bot"
                              ).toString(),
                              cardExpYear: CryptoJS.AES.encrypt(
                                state.cardExpYear,
                                "bot"
                              ).toString(),
                              cvv: CryptoJS.AES.encrypt(
                                state.cvv,
                                "bot"
                              ).toString(),
                            },
                            paymentInCanadian:
                              paymentInCanadian || currency == "CAD",
                          });
                        }}
                      />
                    </Footer>
                    <StripeImage>
                      <img src={StripeLogo} alt="stripe-image" />
                    </StripeImage>
                  </React.Fragment>
                ) : (
                  <h4>Under Construction</h4>
                  // <PayPalButton
                  //   onApprove={(data, actions) => {
                  //     actions.order.capture();
                  //     hide({
                  //       orderId: data?.orderID,
                  //       paypal: true,
                  //       iossNumber: state?.iossNumber,
                  //     });
                  //   }}
                  //   createOrder={(data, actions) =>
                  //     actions.order.create({
                  //       purchase_units: [
                  //         {
                  //           amount: {
                  //             value: paymentInCanadian
                  //               ? (
                  //                   payableAmount * USD_TO_CAD_CONVERSION_RATE
                  //                 ).toFixed(2)
                  //               : payableAmount,
                  //           },
                  //         },
                  //       ],
                  //     })
                  //   }
                  // />
                )}
              </Body>
            )}
          </Container>
        </Dialog>
      )}
    </React.Fragment>
  );
};

export default Stripe;
